import React, {useState, useEffect, useCallback, useMemo} from 'react'
import {useIntl} from 'react-intl'
import {KTCard, KTCardBody, Table, Loading} from '../../../components'
import {CustomCell} from '../../../components/Table/columns/CustomCell'
import {CustomHeader} from '../../../components/Table/columns/CustomHeader'
import {ListHeader} from '../../../components/Table/header/ListHeader'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'

import {detailPageUrl, DetailPage, ExpenseDetailPage} from '../../../helpers'

import {useDispatch, useSelector} from 'react-redux'
import {paymentPlanUnscheduled} from '../../../redux/slices/paymentplan.slice'

function List() {
  const intl = useIntl()
  const dispatch = useDispatch()
  const pageKey = 'UNSCHEDULED'

  const selectPaymentPlanData = (state) => ({
    unscheduled: state.paymentplan.unscheduled,
    loading: state.paymentplan.loading,
  })

  const {unscheduled, loading} = useSelector(selectPaymentPlanData)

  const [params, setParams] = useState()

  useEffect(() => {
    if (params) {
      dispatch(paymentPlanUnscheduled(params))
    }
  }, [dispatch, params])

  const newUrlGenerate = useCallback((data) => {
    if (data && data.expenseInvoiceId > 0) {
      return detailPageUrl(
        ExpenseDetailPage[data && data.expenseInvoiceTypeId],
        data && data.expenseInvoiceId
      )
    }

    return detailPageUrl(DetailPage.SaleInvoice, data && data.saleInvoiceId)
  }, [])

  const handleSorting = useCallback((item) => {
    setParams((prevState) => ({...prevState, sort: item && item.sort, order: item && item.order}))
  }, [])

  const handleSearch = useCallback((item) => {
    setParams((prevState) => ({...prevState, name: item}))
  }, [])

  const handlePagination = useCallback((pagination) => {
    setParams((prevState) => ({...prevState, ...pagination}))
  }, [])

  const handleFilterSubmit = useCallback((values) => {
    setParams({...values})
  }, [])

  const Columns = useMemo(
    () => [
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'UNSCHEDULED.GET.NAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'name',
        Cell: ({...props}) => (
          <CustomCell item={props} to={newUrlGenerate(props.data[props.row.index])} />
        ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'UNSCHEDULED.GET.TOTALPRICE'})}
            className='min-w-125px'
          />
        ),
        accessor: 'totalPrice',
        Cell: ({...props}) => (
          <CustomCell item={props} price to={newUrlGenerate(props.data[props.row.index])} />
        ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'UNSCHEDULED.GET.UNSCHEDULEDPRICE'})}
            className='min-w-125px'
          />
        ),
        accessor: 'unscheduledPrice',
        Cell: ({...props}) => (
          <CustomCell item={props} price to={newUrlGenerate(props.data[props.row.index])} />
        ),
      },
      {
        Header: (props) => (
          <CustomHeader
            tableProps={props}
            handleChangeSorting={handleSorting}
            title={intl.formatMessage({id: 'UNSCHEDULED.GET.INVOICETYPENAME'})}
            className='min-w-125px'
          />
        ),
        accessor: 'invoiceTypeName',
        Cell: ({...props}) => (
          <CustomCell item={props} to={newUrlGenerate(props.data[props.row.index])} />
        ),
      },
    ],
    [intl, handleSorting, newUrlGenerate]
  )

  const buttons = useMemo(() => [], [])

  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'MENU.CASH.UNSCHEDULED'})}</PageTitle>
      <KTCard>
        <ListHeader
          search={handleSearch}
          onSubmit={handleFilterSubmit}
          pages={pageKey}
          buttons={buttons}
        />
        <KTCardBody>
          {!unscheduled && <ListLoading />}
          {unscheduled && (
            <Table
              items={unscheduled}
              cols={Columns}
              handlePagination={handlePagination}
              paddless
              pages={pageKey}
            />
          )}
        </KTCardBody>
      </KTCard>

      {loading && <Loading />}
    </>
  )
}
export {List}
